/**
 * 个人中心相关 API
 */
import { get, post, put } from '@/utils/request'

/** 获取用户信息 */
export async function getUserInfo(requestOptions = {}) {
  return get('/userBaseInfo/getUserInfo', {}, requestOptions)
}

/**
 * 微信扫码登录后绑定手机号（绑定成功即完成登录）
 * @param {Object} data - { openid, type, phone, code, unionid?, referrerCode?, referrerChannel? }
 */
export async function bindPhone(data) {
  return post('/login/bindMobile', data)
}
/** 获取会员信息 */
export async function getUserMemberInfo() {
  return post('/userMemberStatus/getVipExpiresDate')
}
/** 更新预警值 */
export async function editWarn() {
  return post('/userBaseInfo/editWarn')
}

/**
 * 上传更换头像（Header：token；表单字段：file）
 * @param {File} file - 图片文件
 */
export async function uploadAvatar(file) {
  const formData = new FormData()
  formData.append('file', file)
  return post('/common/upload', formData)
}

/** 修改用户资料 (Header：token；Body：{ nickName, avatarUrl })
*/
export async function editUserProfileInfo(data) {
  return post('/userProfileInfo/updateUserProfileInfo', data)
}


/** 更新用户资料 */
export async function updateProfile(data) {
  return put('/user/profile', data)
}

/** 获取订单列表 */
export async function getOrderList(params = {}) {
  return get('/user/orders', params)
}

/** 获取 API Key */
export async function getApiKey() {
  return get('/user/api-key')
}

/** 重新生成 API Key */
export async function regenerateApiKey() {
  return get('/userBaseInfo/updateApiKey')
}

/**用户消费明细*/
export async function getScoreList(params = {}) {
  return get('/score/list', params)
}
//提现
export async function withdrawList(params = {}) {
  return get('/withdraw/list', params)
}
//佣金记录
export async function paidList(params = {}) {
  return get('/paid/list', params)
}
export async function paidIndex(params = {}) {
  return get('/paid/index', params)
}
//获取可提现金额
export async function referrerIndex(params = {}) {
  return get('/referrer/index', params)
}
//获取计费标准
export async function getMoudlePrice(params = {}) {
  return get('/moudle/getMoudlePrice', params)
}
//消费明细会员购买
export async function getUserCardOrder(params = {}) {
  return get('/userCardOrder/getUserCardOrder', params)
}
//消费明细积分购买
export async function getUserScoreOrder(params = {}) {
  return get('/userScoreOrder/getUserScoreOrder', params)
}
//积分充值
export async function getScoreModel(params = {}) {
  return post('/cardDefinition/getScoreModel', params)
}
//会员充值
export async function getCardModel(params = {}) {
  return post('/cardDefinition/getCardModel', params)
}
/**生成会员卡订单 */
export async function generateCardOrder(data) {
  return post('/userCardOrder/buyCard', data)
}
/** 生成会员卡支付订单 */
export async function generateCardPayOrder(data) {
  return post('/pay/toPayCardOrder', data)
}
/** 生成积分订单 */
export async function generateScoreOrder(data) {
  return post('/userScoreOrder/buyScore', data)
}
/** 生成积分支付订单 */
export async function generateScorePayOrder(data) {
  return post('/pay/toPayScoreOrder', data)
}
/** 非SVIP用户生成工作流下载订单（Body: { flowId: string }） */
export async function generateWorkflowOrder(data) {
  return post('/userAgentOrder/buyAgent', data)
}
/** 非SVIP用户工作流订单发起支付（Body: { orderId: string, payType: string }，如 payType: OTHER） */
export async function generateWorkflowPayOrder(data) {
  return post('/pay/toPayAgentOrder', data)
}
/**
 * 是否已购买指定工作流（Query: flowId 为工作流编号，须 string 避免大整数精度问题）
 * @param {{ flowId: string }} params
 */
export async function isWorkflowPurchased(params = {}) {
  return get('/userAgentOrder/checkUserBuyWorkflow', params)
}

// 收款渠道-列表
export async function getPayChannelList(params = {}) {
  return get('/paidChannel/list', params)
}
// 收款渠道-新增
export async function addPayChannel(data) {
  return post('/paidChannel/add', data)
}
// 收款渠道-编辑
export async function editPayChannel(data) {
  return post('/paidChannel/edit', data)
}
// 收款渠道-删除
export async function deletePayChannel(params = {}) {
  return get('/paidChannel/delete', params)
}

// 提现申请
export async function applyWithdraw(data) {
  return post('/withdraw/add', data)
}

// 获取OSS上传凭证
export async function getOssUploadCredential() {
  return get('/common/getAliyunSts')
}

// 推荐会员列表
export async function getRecommendMemberList(params = {}) {
  return get('/referrer/list', params)
}

/**
 * 用户上传资源大小数据（OSS 上传成功后上报，用于统计存储空间）
 * @param {Object} data
 * @param {string} data.userId - 用户 ID
 * @param {string} data.ossKey - OSS 资源路径（Object Key）
 * @param {number|string} data.fileSize - 文件大小（字节）
 * @param {'image'|'audio'|'video'} data.mimeType - 资源类型
 * @param {string} data.url - 完整资源链接
 */
export async function getUserUploadSize(data) {
  return post('/component/addUserSource', data)
}

/**
 * 用户资源数据查询
 * @param {Object} params - 查询参数
 * @param {string} params.page - 页码
 * @param {string} params.size - 每页条数
 * @param {string} params.mimeType - 资源类型（image,audio,video）
 */
export async function getUserSource(params = {}) {
  return get('/userBaseInfo/getUserResourceList', params)
}

/**
 * 删除OSS文件资源
 * @param {Object} data
 * @param {string} data.ossKey - OSS string类型的资源路径（如：uploads/1001/202606/xxx.png）
 */
export async function deleteUserOssSource(params = {}) {
  return get('/component/deleteFile', params)
}

/**
 * 删除用户资源
 * @param {Object} data
 * @param {string} data.id - 资源ID
 */
export async function deleteUserSource(params = {}) {
  return get('/component/deleteUserSource', params)
}
